import { Expose } from "class-transformer";
import { Model } from "../model";

@Expose()
export class ConsultaPagamento extends Model<ConsultaPagamento>  {
  id!: number;
  token!: string;
  idFormaCobranca!: number;
  dataVenda!: string;
  valorTotal!: number;
  tipoPessoa!: string;
  subscritor!: string;
  cpfCnpjSubscritor!: string;
  // valor!: number;
  // quantidade!: number;
  // valorTotalParceladoCartao!: number;
  // bandeiras!: [];
  denominacaoComercial!: string;
  idFamiliaProduto!: number;
  numeroGarantia!: number;

  constructor(response: any) {
    super();
    this.subscritor = response.venda.subscritor;
    this.cpfCnpjSubscritor = response.venda.cpfCnpjSubscritor;
    this.dataVenda = response.venda.dataVenda;
    this.valorTotal = response.venda.valorTotal;
    this.tipoPessoa = response.venda.tipoPessoa;
    this.idFormaCobranca = response.venda.cobranca?.idFormaCobranca;
    // this.bandeiras = response.venda.cobranca?.cartaoCredito.bandeiras;
    // this.quantidade = response.venda.cobranca?.cartaoCredito?.parcela.quantidade;
    // this.valorTotalParceladoCartao = response.venda?.cobranca?.cartaoCredito?.parcela.valorTotalParceladoCartao;
    // this.valor = response.venda.cobranca?.cartaoCredito.parcela.valor;
    this.denominacaoComercial = response.itemComercializacao.denominacaoComercial;
    this.numeroGarantia = response.venda.numeroGarantia;
  }
}
